import { useQuery } from '@tanstack/react-query';
import { companyService } from '../services/companyService';

export function useSelectedCompany() {
  return useQuery({
    queryKey: ['company', 'selected'],
    queryFn: () => companyService.getSelectedCompany(),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 2,
    retryDelay: 1000,
  });
}
